<mat-chip
  *transloco="let t"
  [matTooltip]="
    t('portal.trainings.statuses.' + status.toLowerCase() + '.tooltip')
  "
  class="!rounded-full !text-xs !font-medium !leading-4"
  [ngClass]="getBgColorClass"
>
  <span [ngClass]="status === lpStatus.ACTIVE ? 'text-blue' : ''">
    {{ t('portal.trainings.statuses.' + status.toLowerCase() + '.name') }}
  </span>
</mat-chip>
